<template>
    <app-card
        :ripple="clickable"
        :style="`cursor: ${cursor}`"
        :dense="dense"
        size="fullscreen"
        :loading="loading"
        class="mb-4"
        :elevation="2"
        @click="$emit('click')"
    >
        <template #overline><slot name="overline" /></template>
        <template #title><slot name="title" /></template>
        <template #subtitle><slot name="subtitle" /></template>
        <template #header><slot name="header" /></template>
        <template #actions><slot name="actions" /></template>
        <slot />
    </app-card>
</template>

<script>
export default {
    name: 'KanbanBoard',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        clickable: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        cursor() {
            if (this.loading) {
                return 'loading';
            }

            if (this.clickable) {
                return 'pointer';
            }

            return 'default';
        }
    }
};
</script>
